import React, { useState } from "react";
import WhiteColor from "./WhiteColor";
import FancyColor from "./FancyColor";

const ColorTab = () => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <>
      <div className="custom-tab">
        <div className="tab-idicator">
          <div
            className={`tab-item ${activeTab === 0 ? "active" : ""}`}
            onClick={() => setActiveTab(0)}
          >
            White Color
          </div>
          <div
            className={`tab-item ${activeTab === 1 ? "active" : ""}`}
            onClick={() => setActiveTab(1)}
          >
            Fancy Color
          </div>
        </div>
      </div>
      <div>{activeTab == 0 ? <WhiteColor /> : <FancyColor />}</div>
    </>
  );
};

export default ColorTab;
